import { TFunction } from 'i18next';

import _ from 'lodash';
import {
  LocationMetric,
  LocationMetricDescriptorBase,
} from './locationMetric.types';

export const getLocationMetricDescriptors = (
  t: TFunction<'app'>,
): LocationMetricDescriptorBase[] => [
  {
    type: 'locationOrder',
    path: 'locationOrder',
    rangeType: 'range-linear',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationStatus',
    path: 'locationStatus',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'locationLevel',
    path: 'locationLevel',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'locationLength',
    path: 'locationLength',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'locationWidth',
    path: 'locationWidth',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'locationHeight',
    path: 'locationHeight',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'locationWeight',
    path: 'locationWeight',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'locationBayTitle',
    path: 'locationBayTitle',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationBayPosition',
    path: 'locationBayPosition',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationDepthPosition',
    path: 'locationDepthPosition',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationUsageType',
    path: 'locationUsageType',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locmhtype',
    path: 'locmhtype',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationRackingType',
    path: 'locationRackingType',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'warehouseArea',
    path: 'warehouseArea',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationSide',
    path: 'locationSide',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'congestionZone',
    path: 'congestionZone',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationHeightFromFloor',
    path: 'locationHeightFromFloor',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationDepthFromFront',
    path: 'locationDepthFromFront',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'locationIndexFromFront',
    path: 'locationIndexFromFront',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'bayType',
    path: 'bayType',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'aisleTitle',
    path: 'aisleTitle',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
  {
    type: 'planeTitle',
    path: 'planeTitle',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
  },
];

export const getLocationMetricDescriptorsMap = (t: TFunction<'app'>) =>
  _.keyBy(getLocationMetricDescriptors(t), d => d.type) as Record<
    LocationMetric,
    LocationMetricDescriptorBase
  >;
